export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_10.3a59236e.jpg";